import { combineReducers } from "redux";

import MediaReducer from "./0-media/reducer";
import authReducer from "./1-auth/1-login/reducer";
import myProfileReducer from "./1-auth/2-myProfile/reducer";
import addressReducer from "./1-auth/3-addresses/reducer";
import postsReducer from "./2-post/reducer";
import userReducer from "./3-Users/reducer";
import searchReducer from "./searchSlice";
import bookmarkReducer from "./4-bookmark/reducer";
import likeReducer from "./5-like/reducer";
import commentReducer from "./6-comment/reducer";
import companyReducer from "./7-company/reducer";
import reviewReducer from "./8-review/reducer";
import notificationsReducer from "./9-notification/reducer";
import chatReducer from "./10-chat/reducer";
import contactReducer from "./11-ContactUs/reducer";

const rootReducer = combineReducers({
  auth: authReducer,
  Media: MediaReducer,
  myProfile: myProfileReducer,
  addresses: addressReducer,
  posts: postsReducer,
  users: userReducer,
  search: searchReducer,
  bookmark: bookmarkReducer,
  like: likeReducer,
  comment: commentReducer,
  company: companyReducer,
  review: reviewReducer,
  notification: notificationsReducer,
  chat: chatReducer,
  contact: contactReducer,
});

export default rootReducer;
